import { render } from "./ApplicationsAdmin.vue?vue&type=template&id=4847e66b&scoped=true"
import script from "./ApplicationsAdmin.vue?vue&type=script&lang=js"
export * from "./ApplicationsAdmin.vue?vue&type=script&lang=js"

import "./ApplicationsAdmin.vue?vue&type=style&index=0&id=4847e66b&scoped=true&lang=css"
import "./ApplicationsAdmin.vue?vue&type=style&index=1&id=4847e66b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4847e66b"]])

export default __exports__